import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['integrationSelect', 'nextBtn']
  static values = { integrationType: Number, restaurantId: Number }

  integrationTypeChanged(_event) {
    this.integrationTypeValue = this.integrationSelectTarget.value
  }

  integrationTypeValueChanged(value) {
    if (value === 0) {
      this.nextBtnTarget.disabled = true
      return
    }
    this.nextBtnTarget.disabled = false
  }

  nextClicked(event) {
    event.preventDefault()
    // Currently only simphony is supported. If we add more integrations, we'll need to add a switch statement here
    window.location.href = `/sandbar/admin/restaurants/${this.restaurantIdValue}/simphony_wizard/step_one`
  }
}
